import React from "react"
import ReactMarkdown from "react-markdown"
import { GatsbyImage } from "gatsby-plugin-image"

import Spacer from "./spacer"

export const ModularContent = ({ modules }) => (
	<div className='max-950 ma p20 grey-100'>
		{modules.map(module => {
			if (module.id.includes("Content")) return <Content key={module.id} {...module} />
			if (module.id.includes("Video")) return <YoutubeEmbed key={module.id} {...module} />
			if (module.id.includes("Image")) return <Image key={module.id} {...module} />
			return <><Table key={module.id} {...module} /><Spacer/></>
		})}
	</div>
)

const Content = ({ content }) => <ReactMarkdown className='lh15 mt60 mb60 press--content large op-75 '>{content}</ReactMarkdown>

const Table = ({ tableHeader, rows }) => (
	<div className='table'>
		<TableHeader {...tableHeader[0]} />
		{rows.map(row => (
			<TableRow key={row.id} {...row} />
		))}
	</div>
)

const TableHeader = ({ one, two, three }) => (
	<div className='table-grid table-header'>
		<p className='medium text-center p20 bold'>
			<span className='op-75'>{one}</span>
		</p>
		<p className='medium text-center p20 bold'>
			<span className='op-75'>{two}</span>
		</p>
		<p className='medium text-center p20 bold'>
			<span className='op-75'>{three}</span>
		</p>
	</div>
)

const TableRow = ({ rowItems }) => (
	<div className='table-grid table-rows'>
		{rowItems.map(item => {
			if (item.id.includes("Image"))
				return (
					<picture key={item.id} className='row-item flex align-center justify-center p20'>
						<GatsbyImage image={item.image?.gatsbyImageData} key={item.id} alt='' className='br4 max-75p w-100' />
					</picture>
				)
			return (
				<div key={item.id} className='row-item flex align-center p20 med tracking-wide lh14'>
					<p className='op-50'>{item.text}</p>
				</div>
			)
		})}
	</div>
)

const YoutubeEmbed = ({ youtubeVideo }) => (
	<div className='pos-rel ratio-16-9 m-ratio-1-1 overflow'>
		<iframe title={youtubeVideo.title} width='100%' height='100%' src={`https://www.youtube.com/embed/${youtubeVideo.providerUid}`} frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen></iframe>
	</div>
)

const Image = ({ image }) => (
	<div className='pos-rel ratio-16-9 m-ratio-1-1 overflow'>
		<GatsbyImage image={image?.gatsbyImageData} className='bg-image' alt='' />
	</div>
)
